var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLookupDocument30A2E183(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 29,
    viewBox: "0 0 21 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.28412,
    y: 2.56902,
    width: 15.5,
    height: 21.9,
    rx: 0.75,
    transform: "rotate(-8.47704 1.28412 2.56902)",
    stroke: "black",
    strokeWidth: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.14553,
    y1: 4.32153,
    x2: 14.8494,
    y2: 3.02429,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.47072,
    y1: 8.08192,
    x2: 15.3396,
    y2: 6.31297,
    stroke: "black",
    strokeWidth: 0.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.82448,
    y1: 10.4557,
    x2: 15.6934,
    y2: 8.68675,
    stroke: "black",
    strokeWidth: 0.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4.17824,
    y1: 12.8295,
    x2: 16.0471,
    y2: 11.0605,
    stroke: "black",
    strokeWidth: 0.75
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 4.532,
    y1: 15.2033,
    x2: 16.4009,
    y2: 13.4343,
    stroke: "black",
    strokeWidth: 0.75
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 4.88588,
    y1: 17.577,
    x2: 16.7548,
    y2: 15.8081,
    stroke: "black",
    strokeWidth: 0.75
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 5.23964,
    y1: 19.9508,
    x2: 12.361,
    y2: 18.8895,
    stroke: "black",
    strokeWidth: 0.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0636,
    cy: 12.5569,
    r: 6.5,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5636 18.0569L1.5636 27.0569",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookupDocument30A2E183);
export default __webpack_public_path__ + "static/media/lookup-document.30a2e183.dd8b0abbc94a0615fcf7b2813e37fb70.svg";
export { ForwardRef as ReactComponent };